import config from 'config'

export const isChrome =
  !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)

export const isExtensionInstalled = () => {
  return new Promise((resolve) => {
    if (!isChrome) {
      resolve(false)
    }

    window.chrome.runtime.sendMessage(
      config.DRIFT_VIDEO_EXTENSION_ID,
      { message: 'ping' },
      (response) => {
        if (response && response.res) {
          resolve(response.res === 'pong')
        } else {
          resolve(false)
        }
      }
    )
  })
}

export const hasCreatedVideoAccount = !!localStorage.getItem(
  'video_signup_completed'
)
export const hasSubmittedOnboardingSurvey = !!localStorage.getItem(
  'video_survey_completed'
)
